<template>
	<form-item class="form_radio" :label="$attrs.label">
		<div class="radio__inner">
			<!-- v1.1更新样式-适配长文案 -->
			<van-button
				v-for="(val, idx) in getOptions"
				:key="`col_${ idx }`"
				:type="modelValue === val.value ? 'primary' : 'default'"
				class="float-left"
				:class="{
					round:round,
					plain:plain,
				}"
				plain
				@click="modelValue = val.value"
			>
				{{ val.label }}
			</van-button>
		</div>
	</form-item>
</template>

<script>
export default {
    name: 'FormRadio',
    data: () => ({
        colNum: 3
    }),
    props: {
        value: {
            type: [String, Number, Boolean],
            default: ''
        },
        radioType: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        preview: {
            type: Boolean,
            default: false
        },
        round: {
            type: Boolean,
            default: false
        },
        plain: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modelValue: {
            get () {
                return this.value
            },
            set (val) {
                if (this.preview) return
                this.$emit('input', val)
            }
        },
        getOptions () {
            let arr = []
            this.options.map(v => {
                if (typeof v === 'string') {
                    arr.push({ value: v, label: v })
                } else {
                    arr.push(v)
                }
            })
            return arr
        }
    }
};
</script>

<style scoped lang="less">
.form_radio {
	.radio__inner {
		> div + div {
			margin-top: 28px;
		}
	}
}
</style>
<style lang="less">
.form_radio {
	.radio__inner {
		width: calc(100% + 28px);
		.van-button {
			height: 68px;
			line-height: 68px;
			border-radius: 10px;
			font-size: 26px;
			font-weight: normal;
			padding: 0;
			min-width: calc((100% - 74px) / 3);
			padding: 0 15px;
			margin-right: 24px;
			margin-bottom: 14px;
			&.van-button--default {
				border-color: #f5f6f7;
				background-color: #f5f6f7;
				color: #1f2329;
			}
			&.van-button--primary {
				background: #eefcfc;
				// background-color: mix(@white, @primary, 90%);
			}
		}
		.round {
			border-radius: 34px !important;
		}
		.plain {
			&.van-button--default {
				border-color: #dee0e3;
				background-color: transparent;
				color: @gray-9;
			}
		}
	}
}
</style>
